export function heroVideoAnimation() {
    $("body").addClass("hero-video-init");
    const $window = $(window);
    const animationParent = $(".hero-video-animation");
    const animationParentHolder = animationParent.find(".hero-video-animation-holder");
    const animationVideo = animationParent.find(".hero-video-holder");
    const animationVideoBox = animationVideo.find(".hero-video-box");
    const animationTitle = animationParent.find(".hero-video-title");
    let animationParentTop = 0;
    let animationParentHeight;
    let animationTitleHeight;
    let winTop;
    let windowHeight;
    let animScrollTop;
    let animationVideoWidth;
    let animScrollWidth;
    let animScrollHeight;
    let animationVideoHeight;
    $window.on("load scroll", function () {
        if ($window.innerWidth() > 1200) {
            winTop = $window.scrollTop();
            windowHeight = $window.innerHeight();
            animationTitleHeight = animationTitle.innerHeight();
            animationParentTop = animationParent.offset().top;
            animationParentHeight = animationParent.innerHeight();
            animationVideoHeight = animationVideo.innerHeight();
            animationVideoWidth = animationVideo.innerWidth();
            animationParent.height(windowHeight + animationTitleHeight);
            animScrollWidth = $window.innerWidth() - animationVideoWidth;
            animScrollHeight = windowHeight - animationVideoHeight;
            animScrollTop = animationTitleHeight;
            animationVideo.css({
                "top": animationTitleHeight
            })
            animScrollTop = animationTitleHeight - winTop;
            if (animationTitleHeight / 10 < winTop) {
                animationParentHolder.addClass("hide-button");
            } else {
                animationParentHolder.removeClass("hide-button");
            }
            if (animationTitleHeight / 2.4 < winTop) {
                animationParentHolder.addClass("change-color");
            } else {
                animationParentHolder.removeClass("change-color");
            }
            if (animScrollTop > 0) {
                animationVideo.css({
                    "top": animScrollTop,
                });
                animationVideoBox.css({
                    "width": "calc(100% + " + Math.round((winTop / animationTitleHeight) * animScrollWidth) + "px)",
                    "height": "calc(100% + " + Math.round((winTop / animationTitleHeight) * animScrollHeight) + "px)"
                });
            } else {
                animationVideo.css({
                    "top": 0
                });
            }
            if (winTop + windowHeight > animationParentTop + animationParentHeight) {
                animationVideoBox.css({
                    "width": window.innerWidth,
                    "height": windowHeight
                });
            }
            if (winTop > animationParentTop) {
                animationParentHolder.addClass("fixed");
            } else {
                animationParentHolder.removeClass("fixed");
            }
            if (winTop + windowHeight > animationParentTop + animationParentHeight) {
                animationParentHolder.removeClass("fixed").addClass("bottom");
            } else {
                animationParentHolder.removeClass("bottom");
            }
        }
    });
    animationParent.find(".scroll-bottom-button").on("click", function () {
        if ($window.innerWidth() > 1200) {
            $('body,html').animate({scrollTop: animationParent.innerHeight() - $window.innerHeight()}, 800);
        } else {
            $('body,html').animate({scrollTop: animationParent.innerHeight()}, 800);
        }
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/heroVideoAnimation.js